import React from 'react';
import { useMutation } from '@apollo/client/react';
import BoxResizer from '../../../components/BoxResizer';
import { useFigureStore } from '../../../components/store';
import { deriveCoords } from '../../../components/BoxResizerParts';
import StepActions from './StepActions';
import StepShell from './StepShell';
import { pageImage } from './wizardUtils';
import { CREATE_FIGURE, DELETE_FIGURE } from '../../graphql/mutations';

// Bounding box editing step; finished boxes are handed to `onFinishFigures`.
export default function ResizeBoxesStep({
  resource,
  sites,
  onFinishFigures,
  onCancel,
  message = 'Resize bounding boxes and create new boxes for objects related to this object.'
}) {
  const image = pageImage(resource);
  const { figures, setFigures, addFigure, removeFigure } = useFigureStore();
  const [createFigure] = useMutation(CREATE_FIGURE);
  const [deleteFigure] = useMutation(DELETE_FIGURE);

  const handleCreateFigure = async (type, coords) => {
    const box = coords ?? deriveCoords(type, resource);
    const result = await createFigure({
      variables: { input: { pageId: resource.page.id, parentId: resource.id, type, ...box } }
    });
    const figure = { ...result.data.createFigure, typeName: type };
    addFigure(figure);
    return figure.id;
  };

  const handleRemoveFigure = async (id) => {
    await deleteFigure({ variables: { input: { id } } });
    removeFigure(figures[id]);
  };

  if (!image) {
    return (
      <StepShell>
        <div className="alert alert-danger">No page image found.</div>
        <StepActions onCancel={onCancel} />
      </StepShell>
    );
  }

  return (
    <StepShell>
      <h3>Resize Boxes</h3>
      <div className="alert alert-primary mb-3">{message}</div>
      <BoxResizer
        grave={resource}
        sites={sites}
        image={image}
        page={resource.page}
        figures={figures}
        setFigures={setFigures}
        addFigure={addFigure}
        removeFigure={removeFigure}
        onCreateFigure={handleCreateFigure}
        onRemoveFigure={handleRemoveFigure}
        onFinish={onFinishFigures}
      />
      <StepActions onCancel={onCancel} />
    </StepShell>
  );
}
